

// icons
import { mail, person, chatbubbleEllipsesOutline, } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonGrid, IonRow, IonButtons, IonButton, IonIcon, IonBackButton,
        IonItem, IonLabel, IonList, IonListHeader,
        IonInput, IonTextarea,
        loadingController, } from '@ionic/vue';
import ProductCard from "@/components/templates/ProductCard.vue";

import { computed, ref } from 'vue';

// services
import CommonService from '@/services/CommonService';

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { utils } from '@/composables/utils';

export default {
  name: 'FeedbackPage',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
                IonGrid, IonRow, IonButtons, IonButton, IonIcon, IonBackButton,
                IonItem, IonLabel, IonList, IonListHeader,
                IonInput, IonTextarea, ProductCard, },
  setup() {
    const store = useStore();

    const user = computed(() => store.state.user);
    const name = ref(user.value.firstName || "");
    const email = ref(user.value.email || "");
    const feedback = ref("");
    const product = ref<any>(null);

    const route = useRoute();
    const passedProduct: any = route.params.passedProduct; // route paramters (mainly ID)
    if (passedProduct) { // from product detail page (enquiry)
      console.log(passedProduct);
      product.value = JSON.parse(passedProduct);
    } 

    // methods
    const { t } = useI18n();
    const { presentToast } = utils();

    const submitFeedback = async () => {
      const loading = await loadingController.create({});
      await loading.present();
      const res = await CommonService.createNewFeedback(name.value, email.value, feedback.value, product.value);
      loading.dismiss();
      feedback.value = "";
      presentToast( t('FeedbackPage.feedbackSubmitted'), 5000, 'top' );
    }
    
    return {
      // icons
      mail, person, chatbubbleEllipsesOutline,
      
      // variables
      name, email, feedback, product,

      // methods
      t, submitFeedback,
    }
  },
}
